/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_SlowestInputs */

const en_ui_laps_slowest = /** @type {(inputs: Ui_Laps_SlowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slowest`)
};

const de_ui_laps_slowest = /** @type {(inputs: Ui_Laps_SlowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsamste`)
};

/**
* | output |
* | --- |
* | "Slowest" |
*
* @param {Ui_Laps_SlowestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_slowest = /** @type {((inputs?: Ui_Laps_SlowestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_SlowestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_slowest(inputs)
	return de_ui_laps_slowest(inputs)
});